import SearchDataGrid, {
  SearchDataGridProps,
} from '../search-data-grid.component';

const SearchDataGridWithTotalRow = (props: SearchDataGridProps) => {
  return (
    <SearchDataGrid
      getRowClassName={params =>
        params.row.id === 'total' ? 'totals-row' : ''
      }
      sx={{
        '& .totals-row': {
          fontWeight: 'bold',
        },
      }}
      {...props}
    />
  );
};

export default SearchDataGridWithTotalRow;
